import { FC, memo, useState } from 'react';
import styled, { useTheme } from 'styled-components';
import { useDialog } from '../../../contexts/dialog';
import { SizesEnum } from '../../../contexts/dialog/types';
import Button from '../../atoms/Button';
import Text from '../../atoms/Text';

import { useTalk } from '../../../contexts/talk';
import { QuestionRound } from '../../../contexts/talk/types';
import client from '../../../api';
import config from '../../../api/config';
import img from './profile.png';

const S = {
  Container: styled.div<{ opened?: boolean }>`
    display: ${({ opened }) => (opened ? 'flex' : 'none')};
    width: 295px;
    border-radius: 32px;
    overflow: hidden;
    flex-direction: column;
    justify-content: flex-end;
    box-shadow: 0px 8px 24px rgba(46, 45, 55, 0.24);
    position: fixed;
    z-index: 8;
    right: 25px;
    bottom: 96px;
  `,
  Header: styled.div`
    height: 90px;
    background: #cc0000;
    border-radius: 32px 32px 0 0;
    padding: 20px 24px 0;
  `,
  Body: styled.div`
    border-radius: 32px;
    background: #fff;
    margin-top: -25px;
    padding: 32px 24px 16px;
  `,
  TextCenter: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    text-align: center;
    height: 100%;
  `,
  BoxImages: styled.div`
    /* margin: 0 0 18px; */
  `,
  Logo: styled.div`
    flex: 1;
    display: flex;
    align-items: flex-end;
    margin: 18px 0 0;
  `,
};

const MediumFrame: FC = () => {
  const theme = useTheme();
  const [loading, setLoading] = useState(false);

  const { appendRound } = useTalk();

  const {
    dialogState: { opened },
    handleDialog,
  } = useDialog();

  const handleStart = async () => {
    setLoading(true);

    try {
      const { data, headers } = await client.post<QuestionRound>('/chats');

      localStorage.setItem(config.localStorage.xKey, headers?.['x-key']);

      appendRound({ question: data });

      setTimeout(() => {
        handleDialog({
          size: SizesEnum.LG,
          opened: true,
        });

        setLoading(false);
      }, 1000);
    } catch (error) {
      setLoading(false);
    }
  };

  if (!opened) return null;

  return (
    <S.Container opened={opened}>
      <S.Header>
        <Text fontSize='20px' color='#fff' lineHeight='30px' bold>
          Olá
        </Text>
        <Text fontSize='14px' color='#fff' lineHeight='21px'>
          Como podemos te ajudar hoje? 👋
        </Text>
      </S.Header>
      <S.Body>
        <S.TextCenter>
          <S.BoxImages>
            <img src={img} alt='' />
          </S.BoxImages>

          <Text fontSize='18px' color='#353945' lineHeight='27px' bold margin='18px 0 18px'>
            Vamos conversar?
          </Text>
          {/* <Text fontSize='14px' color='#353945' lineHeight='21px' margin='16px 0 0'>
            Olá, nossa equipe está aqui para te ajudar
          </Text> */}
          <Button
            onClick={handleStart}
            loading={loading}
            bgColor={theme.grayColor}
            height='53px'
            color='#fff'
            bold
            full
          >
            Iniciar conversa
          </Button>

          <S.Logo>
            <svg
              width='71'
              height='13'
              viewBox='0 0 71 13'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M9.72598 5.03441C9.96002 5.41469 10.077 5.85347 10.1063 6.29225C12.2712 6.84805 13.7339 8.04739 13.7047 9.36374C13.7047 11.2944 10.8377 12.8448 7.29782 12.8448C3.75798 12.8448 0.890991 11.2944 0.890991 9.36374C0.890991 7.98888 2.38299 6.78954 4.5186 6.23375C4.5186 6.76029 4.63562 7.28683 4.89892 7.75486L6.91751 11.2359C7.06379 11.4991 7.18081 11.7917 7.23932 12.0842L7.32708 11.9379C7.82441 11.0896 7.82441 10.0073 7.32708 9.15897L5.71806 6.38001C5.22072 5.50244 5.22072 4.44936 5.71806 3.60105L5.80582 3.45479C5.86433 3.74731 5.98135 4.03983 6.12763 4.3031L7.06379 5.94123L8.52653 8.48617C8.67281 8.74944 8.78983 9.04196 8.84834 9.33448L8.9361 9.18822C9.43344 8.33991 9.43344 7.25758 8.9361 6.40926L7.32708 3.6303C6.82975 2.78199 6.82975 1.69965 7.32708 0.851339L7.41484 0.705078C7.47335 0.9976 7.59037 1.29012 7.73665 1.55339L9.72598 5.03441ZM16.292 11.1383C16.15 11.5502 16.0932 11.8738 16.0648 12.374C16.7179 12.6976 17.5131 12.8447 18.4502 12.8447C20.4379 12.8447 21.4602 11.8738 21.4602 10.491C21.4602 9.31414 20.8355 8.60803 19.3589 7.96076L18.7341 7.69597C17.9106 7.34291 17.4563 6.96043 17.4563 6.34259C17.4563 5.69532 17.9106 5.28342 18.9329 5.28342C19.4724 5.28342 20.2392 5.40111 20.8639 5.63648C20.9775 5.28342 21.0627 4.90094 21.0911 4.4302C20.4379 4.19483 19.728 4.07715 18.9613 4.07715C17.0871 4.07715 16.15 4.95979 16.15 6.34259C16.15 7.6077 16.8883 8.25497 17.9958 8.75513L18.5921 8.9905C19.6712 9.49066 20.1256 9.8143 20.1256 10.5204C20.1256 11.2559 19.5008 11.609 18.4218 11.609C17.797 11.609 16.9451 11.4619 16.292 11.1383ZM28.2048 6.4453V12.3639H26.9573L26.8979 11.6456C26.5415 12.1628 26.0365 12.5076 25.1751 12.5076C23.5712 12.5076 22.4722 11.3583 22.4722 9.37588C22.4722 7.30723 23.6306 6.10052 25.888 6.10052C26.7791 6.12926 27.5217 6.21545 28.2048 6.4453ZM26.8563 7.17177V11.0187C26.4993 11.2871 26.0827 11.4661 25.5174 11.4959C24.3272 11.4959 23.8214 10.6012 23.8214 9.34874C23.8214 7.97695 24.476 7.11212 25.8745 7.11212C26.2613 7.11212 26.5885 7.11212 26.8563 7.17177ZM34.9495 8.4518V12.5076H33.6155V8.68692C33.6155 7.71704 33.2894 7.27619 31.9553 7.27619C31.6292 7.27619 31.2735 7.30558 30.8881 7.36436V12.5076H29.5541V6.45327C30.4138 6.24754 31.3624 6.10059 31.985 6.10059C34.238 6.12998 34.9495 6.98229 34.9495 8.4518ZM39.6127 11.5027C39.3533 11.622 38.9786 11.6816 38.6039 11.6816C37.9699 11.6816 37.5952 11.3536 37.5952 10.5783V7.56627H39.5551C39.6127 7.20841 39.6415 6.82073 39.6703 6.40323H37.5952V4.07715C37.1917 4.07715 36.7017 4.13679 36.2982 4.2859V10.7572C36.2982 12.2483 37.1052 12.8447 38.3734 12.8447C38.7192 12.8447 39.1227 12.785 39.4686 12.6359C39.5262 12.2781 39.5839 11.8606 39.6127 11.5027ZM45.7409 6.4453V12.3639H44.4934L44.434 11.6456C44.0775 12.1628 43.5726 12.5076 42.7112 12.5076C41.1073 12.5076 40.0083 11.3583 40.0083 9.37588C40.0083 7.30723 41.1667 6.10052 43.4241 6.10052C44.3152 6.12926 45.028 6.21545 45.7409 6.4453ZM44.3908 7.1717V11.0187C44.0635 11.2871 43.6171 11.466 43.0518 11.4958C41.8617 11.4958 41.3558 10.6012 41.3558 9.34868C41.3558 7.97689 42.0104 7.11206 43.4089 7.11206C43.7957 7.11206 44.123 7.11206 44.3908 7.1717ZM52.4856 8.4518V12.5076H51.1294V8.68692C51.1294 7.71704 50.8051 7.27619 49.4783 7.27619C49.154 7.27619 48.8002 7.30558 48.417 7.36436V12.5076H47.0902V6.45327C47.9452 6.24754 48.8887 6.10059 49.5078 6.10059C51.7485 6.12998 52.4856 6.98229 52.4856 8.4518ZM59.2293 12.3636V4.07717C58.7861 4.07717 58.3133 4.10594 57.8996 4.22103V6.17756C57.5745 6.12001 57.2495 6.09124 56.8949 6.09124C54.6491 6.09124 53.4967 7.29968 53.4967 9.3713C53.4967 11.3566 54.59 12.5075 56.1857 12.5075C57.0722 12.5075 57.5745 12.1622 57.9291 11.6156L57.9882 12.3636H59.2293ZM57.88 11.0187V7.23135C57.523 7.1717 57.1659 7.11206 56.8089 7.11206C55.4699 7.11206 54.8451 7.94706 54.8451 9.34868C54.8451 10.6012 55.3509 11.4958 56.5411 11.4958C57.0766 11.466 57.523 11.2871 57.88 11.0187ZM61.6069 9.85246H65.9138C65.9732 9.50613 65.9732 9.21753 65.9732 8.81348C65.9732 7.31273 65.1415 6.10059 63.2109 6.10059C61.0723 6.10059 60.2406 7.51475 60.2406 9.27525C60.2406 11.2955 61.3099 12.5076 63.5673 12.5076C64.3099 12.5076 64.9336 12.3922 65.5574 12.1324C65.6203 11.8677 65.6683 11.5599 65.7121 11.2799L65.7123 11.2788C65.7304 11.1624 65.7479 11.0508 65.7653 10.9492C65.1118 11.2666 64.3693 11.4109 63.6267 11.4109C62.4089 11.4109 61.7851 10.9203 61.6069 9.85246ZM61.5892 8.79813H64.6242C64.6242 7.73653 64.0886 7.11206 63.1662 7.11206C62.1843 7.14328 61.6785 7.70531 61.5892 8.79813ZM70.2406 7.33497C70.2987 7.07046 70.3569 6.60022 70.3569 6.18876C70.1631 6.14957 69.8917 6.13651 69.6204 6.12345C69.4848 6.11691 69.3491 6.11038 69.2231 6.10059C68.4964 6.10059 67.5371 6.24754 66.9847 6.45327V12.5076H68.2929V7.33497C68.6127 7.30558 68.9324 7.27619 69.2522 7.27619C69.6048 7.27619 69.8815 7.30178 70.1767 7.32908L70.2406 7.33497Z'
                fill='#B1B5C4'
              />
            </svg>
          </S.Logo>
        </S.TextCenter>
      </S.Body>
    </S.Container>
  );
};

export default memo(MediumFrame);
